import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {
    Box,
    Button,
    FormControlLabel,
    Modal,
    Radio,
    RadioGroup,
    Typography,
    useMediaQuery
} from "@mui/material";
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import {startUploadingImagesProgressPopup} from "../../../store/actionCreators/uploadingImagesProgressActionCreator";
import {createFlyerFromJpegFiles} from "../../../store/actionCreators/flyerFromJpegsActionCreator";
import {PopupHeader} from "../../com/popupHeader/popupHeader";

interface Props {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
}

export const CreateFlyerWithJpegsPages: React.FC<Props> = ({
                                                               isOpen,
                                                               setIsOpen
                                                           }) => {
    const dispatch = useDispatch();
    const isXs = useMediaQuery(`(max-width:699px)`);
    const flyersState = useTypedSelector((state) => state.flyers);
    const [value, setValue] = useState<string>("0");

    const onJpegsSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            const files = Array.from(event.target.files);
            dispatch(startUploadingImagesProgressPopup());
            dispatch(createFlyerFromJpegFiles(files, Number(value), flyersState));
            onClose();
        }
    }
    const onClose = () => {
        setIsOpen(false);
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setValue(value);
    }

    return (
        <Modal open={isOpen} disableScrollLock={true}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isXs ? `90vw` : `25vw`,
                    minWidth: isXs ? "auto" : `420px`,
                    maxWidth: `90vw`,
                    backgroundColor: `#ffffff`,
                    display: "flex",
                    flexFlow: "column",
                    maxHeight: `90vh`,
                }}
            >
                <PopupHeader onClose={onClose} headerCaption={"Page size setting for JPG Page Upload"}/>
                <Box
                    pt={"24px"}
                    px={"24px"}
                >
                    <Typography>
                        All Pages in this flyer should be:
                    </Typography>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={value}
                        name="radio-buttons-flyer-jpgs"
                        onChange={handleChange}
                    >
                        <FormControlLabel sx={{marginBottom: "0"}} value="0" control={<Radio />} label="No Restriction" />
                        <FormControlLabel sx={{marginBottom: "0"}} value="1" control={<Radio />} label="Equal Width (different height)" />
                        <FormControlLabel sx={{marginBottom: "0"}} value="2" control={<Radio />} label="Equal Height (different width)" />
                    </RadioGroup>
                </Box>
                <Box
                    p={"24px"}
                >
                    <Button
                        variant={`contained`}
                        component="label"
                        sx={{
                            width: `100%`,
                            color: `initial`,
                            background: `#014780`,
                            // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
                            height: `40px`,
                            borderRadius: `0`,
                            margin: "0",
                            '&:hover': {
                                background: `#014780`,
                                opacity: `0.7`
                            },
                            '&:disabled': {
                                opacity: `0.5`
                            }
                        }}
                    >
                        <Typography color={"#ffffff"}>
                            Upload
                        </Typography>
                        <input
                            type="file"
                            accept={`.jpg, .jpeg`}
                            multiple={true}
                            onChange={onJpegsSelected}
                            hidden
                        />
                    </Button>

                    {/*<Button*/}
                    {/*    onClick={createFlyer}*/}
                    {/*    sx={{*/}
                    {/*        width: `100%`,*/}
                    {/*        color: `initial`,*/}
                    {/*        background: `#014780`,*/}
                    {/*        // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,*/}
                    {/*        height: `40px`,*/}
                    {/*        borderRadius: `0`,*/}
                    {/*        margin: "0",*/}
                    {/*        '&:hover': {*/}
                    {/*            background: `#014780`,*/}
                    {/*            opacity: `0.7`*/}
                    {/*        },*/}
                    {/*        '&:disabled': {*/}
                    {/*            opacity: `0.5`*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <Typography color={"#ffffff"}>*/}
                    {/*        Save*/}
                    {/*    </Typography>*/}
                    {/*</Button>*/}
                </Box>
            </Box>

        </Modal>
    )
}